export default "__VITE_ASSET__mEbwP6pH__"